import { render, staticRenderFns } from "./CheckTable.vue?vue&type=template&id=6c5d540c&scoped=true"
import script from "./CheckTable.vue?vue&type=script&lang=js"
export * from "./CheckTable.vue?vue&type=script&lang=js"
import style0 from "./CheckTable.vue?vue&type=style&index=0&id=6c5d540c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d540c",
  null
  
)

export default component.exports